import React from "react";
import { formatDateString } from "common/utils/dates";
import { pluralize } from "common/utils/strings";
import type { SubmissionTypeVersion } from "../../../../../../generated/graphql";
import { spacing } from "../../../../../../stitches.config";
import { FlexRow } from "../../../../../Common/__styles__/Layout";
import Divider from "../../../../../Common/Divider";
import { Icon } from "../../../../../Common/Icons/LucideIcons";
import { Title } from "../../../../../Common/Typography";
import { ColumnWrapper } from "../__styles__/SubmissionsBuilder";
import {
  SUBMISSIONS_BUILDER_MODE,
  useSubmissionsBuilderMode,
} from "../SubmissionsBuilderContext";

// @ts-expect-error - unused for now
function generateTitle({
  version,
  isCurrent,
}: {
  version: Pick<SubmissionTypeVersion, "version" | "updatedAt">;
  isCurrent: boolean;
}): string {
  if (isCurrent) {
    return `Current version`;
  }

  return `Version ${version.version} · ${formatDateString({
    dateString: version.updatedAt,
    format: "MM D, YYYY H:MM",
  })}`;
}

// @ts-expect-error - unused for now
function generateDescription({
  version,
  isCurrent,
}: {
  version: Pick<SubmissionTypeVersion, "submissionCount">;
  isCurrent: boolean;
}): string {
  const noun = pluralize({
    count: version.submissionCount,
    options: { singular: "record", plural: "records" },
  });

  return `${version.submissionCount} ${noun}${isCurrent ? " created" : ""}`;
}

export function VersionHistory() {
  const [, setMode] = useSubmissionsBuilderMode();

  return (
    <ColumnWrapper>
      <FlexRow css={{ justifyContent: "space-between", alignItems: "center" }}>
        <Title size="large" type="semiBold">
          Version history
        </Title>
        <Icon
          iconName="x"
          size={16}
          color="contentSecondary"
          onClick={() => setMode(SUBMISSIONS_BUILDER_MODE.BUILD)}
          testId="close-version-history"
        />
      </FlexRow>
      <Divider margins={`0px -${spacing.l.value}`} />
    </ColumnWrapper>
  );
}
